module.exports = __webpack_public_path__ + "static/media/satya.9d83bd6a.jpeg";